"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const styles_1 = require("@material-ui/core/styles");
const Commissioner_Regular_ttf_1 = __importDefault(require("../../src/assets/fonts/Commissioner-Regular.ttf"));
const icons_1 = require("@material-ui/icons");
const commissioner = {
    fontFamily: 'Commissioner',
    fontStyle: 'normal',
    fontWeight: 400,
    src: `
    local('Comissioner'),
    local('Commissioner-Regular'),
    url(${Commissioner_Regular_ttf_1.default}) format('truetype')
  `,
};
exports.theme = styles_1.createMuiTheme({
    /** Colors */
    palette: {
        primary: {
            light: '#EDF5FA',
            main: '#1E678F',
            dark: '#081426',
        },
        secondary: {
            light: '#F0F2F5',
            main: '#ECECEE',
            dark: '#CCCED0',
        },
        text: {
            primary: '#333333',
            secondary: '#575757',
        },
        common: {
            white: '#FFFFFF',
            black: '#000000',
        },
    },
    /** Typography */
    typography: {
        fontFamily: '"Commissioner", sans-serif;',
        h1: {
            color: '#1E678F',
            fontSize: '40px',
            lineHeight: '48px',
            letterSpacing: 0,
            fontWeight: 'bold',
        },
        h2: {
            color: '#081426',
            fontSize: '32px',
            lineHeight: '40px',
            letterSpacing: 0,
            fontWeight: 'bold',
        },
        h3: {
            color: '#39A9B0',
            fontSize: '27px',
            lineHeight: '32px',
            letterSpacing: 0,
            fontWeight: 'bold',
        },
        h4: {
            color: '#009B58',
            fontSize: '20px',
            lineHeight: '24px',
            letterSpacing: 0,
            fontWeight: 600,
        },
        subtitle1: {
            color: '#333333',
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: 0,
            fontWeight: 600,
        },
        subtitle2: {
            color: '#333333',
            fontSize: '14px',
            lineHeight: '16px',
            letterSpacing: 0,
            fontWeight: 600,
        },
        body1: {
            color: '#333333',
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: 0,
        },
        body2: {
            color: '#333333',
            fontSize: '14px',
            lineHeight: '16px',
            letterSpacing: 0,
        },
        caption: {
            color: '#333333',
            fontSize: '20px',
            lineHeight: '32px',
            letterSpacing: 0,
        },
        overline: {
            color: '#333333',
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: 0,
            fontWeight: 'bold',
            textDecoration: 'underline',
        },
        button: {
            fontSize: '14px',
            lineHeight: '16px',
            letterSpacing: 0,
            textTransform: 'capitalize',
        },
    },
    /** Props */
    props: {
        MuiSelect: {
            IconComponent: icons_1.KeyboardArrowDown,
        },
    },
    /** Overrides */
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '@font-face': [commissioner],
                '#root': {
                    display: 'flex',
                    flexDirection: 'column',
                },
                ul: {
                    padding: '0 0 0 1rem',
                    margin: 0,
                },
                body: {
                    lineHeight: 1.5,
                },
            },
        },
        MuiAppBar: {
            root: {
                backgroundColor: '#fff',
            },
        },
        MuiContainer: {
            root: {
                '@media (max-width:750px)': {
                    paddingLeft: '10px',
                    paddingRight: '10px',
                },
            },
        },
        MuiButton: {
            root: {
                fontSize: '14px',
                lineHeight: '16px',
                letterSpacing: 0,
                textTransform: 'capitalize',
                textAlign: 'center',
                borderRadius: '4px',
                '&:disabled': {
                    backgroundColor: '#A09FA8',
                    color: '#747378',
                },
            },
            containedPrimary: {
                color: '#FFFFFF',
                fontWeight: 600,
                backgroundColor: '#1E678F',
                lineHeight: '30px',
                minWidth: '160px',
                '&:hover': {
                    backgroundColor: '#1E678F',
                    boxShadow: 'none',
                },
            },
            containedSecondary: {
                color: '#1E678F',
                fontWeight: 600,
                backgroundColor: '#EDF5FA',
                boxShadow: 'none',
                '&:hover': {
                    backgroundColor: '#B3CCD4',
                    boxShadow: 'none',
                },
                '&:disabled': {
                    backgroundColor: '#EDF5FA',
                },
            },
            sizeSmall: {
                fontSize: '11px',
                lineHeight: '16px',
                padding: '4px',
                margin: '5px',
            },
            sizeLarge: {
                fontSize: '16px',
                lineHeight: '24px',
                fontWeight: 600,
            },
            outlinedSecondary: {
                border: '1px solid #009B58',
                backgroundColor: '#F6FFED',
                color: '#009B58',
                fontWeight: 'normal',
            },
        },
        MuiIconButton: {
            root: {
                padding: '5px',
                boxShadow: 'none',
            },
        },
        MuiMenu: {
            list: {
                minWidth: 175,
            },
        },
        MuiMenuItem: {
            root: {
                fontSize: 16,
            },
        },
        MuiLink: {
            root: {
                color: '#000000',
                width: 'fit-content',
                fontWeight: 'bold',
                textDecoration: 'underline',
                '&:hover': {
                    opacity: '0.75',
                },
            },
        },
        MuiTableCell: {
            root: {
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
            },
        },
        MuiInputBase: {
            root: {
                border: `1px solid #ECECEE`,
                borderRadius: '4px',
            },
            input: {
                backgroundColor: '#F0F2F5',
            },
        },
        MuiFilledInput: {
            root: {
                backgroundColor: '#F0F2F5',
                '&:hover': {
                    backgroundColor: '#F0F2F5',
                },
            },
            input: {
                backgroundColor: '#F0F2F5',
                '&:hover': {
                    backgroundColor: '#F0F2F5',
                },
                '&:focus': {
                    backgroundColor: 'rgba(0, 0, 0, 0)',
                },
            },
        },
        MuiSelect: {
            root: {
                backgroundColor: '#F0F2F5',
            },
            icon: {
                height: '32px',
                width: '32px',
            },
        },
        MuiCheckbox: {
            root: {
                color: '#1E678F',
                transform: 'scale(1.3)',
            },
        },
    },
});
